import { BookingEventIncidentReport, IncidentType } from '@bookings/interfaces/booking-event';

export const reportIncidentFields = {
  realNumberOfParticipants: {
    fieldPath: 'real_number_of_participants',
    fieldReadPath: 'real_number_of_participants',
    name: 'real_number_of_participants',
    label: 'bookings.booking_events.real_number_of_participants.label',
    id: 'global__real_number_of_participants',
    warningRules: [],
    veeValidation: false,
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '1',
    },
  },
  realNumberOfParticipantsDescription: {
    fieldPath: 'real_number_of_participants_description',
    fieldReadPath: 'real_number_of_participants_description',
    name: 'real_number_of_participants_description',
    label: 'bookings.booking_events.real_number_of_participants_description.label',
    inputType: 'textarea',
    options: [],
    id: 'global__real_number_of_participants_description',
    rules: ['string', 'max:250'],
    fieldAttributes: {
      autocomplete: 'off',
      rows: 2,
    },
    warningRules: [],
    veeValidation: false,
  },

  incidentToReport: {
    fieldPath: 'incident_to_report',
    fieldReadPath: 'incident_to_report',
    name: 'incident_to_report',
    label: 'bookings.booking_events.incident_to_report.label',
    id: 'incident_to_report',
    rules: ['boolean'],
    warningRules: [],
    veeValidation: false,
  },

  incidentType: {
    fieldPath: 'incident_type',
    fieldReadPath: 'incident_type',
    name: 'incidentTypeSelected',
    label: 'bookings.booking_events.incident_type.label',
    options: [
      { text: 'bookings.booking_events.incident_type.infra_damage', value: 'infra_damage' },
      {
        text: 'bookings.booking_events.incident_type.participant_issue',
        value: 'participant_issue',
      },
      { text: 'bookings.booking_events.incident_type.other', value: 'other' },
    ],
    id: 'global__incident_type_selected',
    rules: ['required'],
    veeValidation: false,
    defaultValue: IncidentType.InfrastructureDamage,
  },
  incidentDescription: {
    fieldPath: 'incident_description',
    fieldReadPath: 'incident_description',
    name: 'incident_description',
    label: 'bookings.booking_events.incident_description.label',
    inputType: 'textarea',
    options: [],
    id: 'global__incident_description',
    rules: ['string', 'max:500'],
    fieldAttributes: {
      autocomplete: 'off',
      rows: 4,
    },
    warningRules: [],
    veeValidation: false,
  },
};

export type ReportIncidentKeys = keyof BookingEventIncidentReport;

export type ReportIncidentErrorObject = Partial<Record<ReportIncidentKeys, string[]>>;
